import { Classes } from "@blueprintjs/core";
import * as React from "react";
import UserIcon from "../../components/UserIcon";
import { MemberContainer } from "./HomeTeam";

export interface ITeamPlaceholderProps {}

export const TeamPlaceholder: React.FunctionComponent<ITeamPlaceholderProps> = (
  props
) => {
  const placeholderData = [...Array(8)].map((_) =>
    (Math.random() + 1)
      .toString(30)
      .substring(0, Math.floor(Math.random() * 30) + 10)
  );

  return (
    <>
      {placeholderData?.map((item) => (
        <MemberContainer>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <UserIcon placeholderMode={true} size={50} fontSize={20} />
          </div>
          <span className={Classes.SKELETON}>{item}</span>
        </MemberContainer>
      ))}
    </>
  );
};

export default TeamPlaceholder;
